import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestBuilder } from '../helpers/rest.builder';
import {
  IGenerateAmpApiKeyRequest,
  IGenerateApiKeyRequest,
  IGenerateKeyResult,
  IPreviousTokensServerResponse,
} from '../../../../shared/interfaces/user-api-key.interface';
import { EmptyObject } from '../../../../shared/interfaces/empty-object.interface';
import { SharedCommonUtility } from '../../../../shared/utils/common.utility';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsRestAPI {
  private restBuilder: RestBuilder;

  constructor(private httpClient: HttpClient) {
    this.restBuilder = new RestBuilder();
  }

  // POST /integrations/generate-api-key
  public generateApikey(name: string, expiry?: Date, reminderDays?: number): Observable<IGenerateKeyResult> {
    const url: string = this.restBuilder.create().integrations().generateApiKey().getApiUrl();
    const body: IGenerateApiKeyRequest = {
      name: name,
    };

    if (SharedCommonUtility.notNullish(expiry)) {
      body.expiry = expiry;
    }

    if (SharedCommonUtility.notNullish(reminderDays)) {
      body.reminderDays = reminderDays;
    }

    return this.httpClient.post<IGenerateKeyResult>(url, body);
  }

  // DELETE /integrations/generate-api-key/{apiKeyId}
  public revokeApikey(name: string): Observable<IGenerateKeyResult> {
    const url: string = this.restBuilder.create().integrations().deleteApiKey(name).getApiUrl();
    return this.httpClient.delete<IGenerateKeyResult>(url);
  }

  // POST /integrations/generate-browser-extension-key
  public generateBrowserExtensionKey(): Observable<IGenerateKeyResult> {
    const url: string = this.restBuilder.create().integrations().generateBrowserExtensionKey().getApiUrl();
    return this.httpClient.post<IGenerateKeyResult>(url, undefined);
  }

  // GET /integrations/previous-tokens-info
  public getPreviousTokensInfo(): Observable<IPreviousTokensServerResponse[]> {
    const url: string = this.restBuilder.create().integrations().getPreviousTokensInfo().getApiUrl();
    return this.httpClient.get<IPreviousTokensServerResponse[]>(url);
  }

  // POST /integrations/amp-api-key
  public generateAmpApiKey(tenantId: string): Observable<IGenerateKeyResult> {
    const url: string = this.restBuilder.create().integrations().ampApiKey().getApiUrl();
    const body: IGenerateAmpApiKeyRequest = {
      tenantId: tenantId,
    };
    return this.httpClient.post<IGenerateKeyResult>(url, body);
  }

  // DELETE /integrations/amp-api-key
  public deleteAmpApiKey(tenantId: string): Observable<EmptyObject> {
    const url: string = this.restBuilder.create().integrations().ampApiKey(tenantId).getApiUrl();

    return this.httpClient.delete<EmptyObject>(url, {});
  }

  // GET /integrations/amp-api-key
  public getAmpApiKey(tenantId: string): Observable<IPreviousTokensServerResponse | null> {
    const url: string = this.restBuilder.create().integrations().ampApiKey(tenantId).getApiUrl();

    return this.httpClient.get<IPreviousTokensServerResponse>(url);
  }

  public createScanningAgentApiKey(): Observable<IGenerateKeyResult> {
    const url: string = this.restBuilder.create().integrations().scanningAgentApiKey().getApiUrl();
    return this.httpClient.post<IGenerateKeyResult>(url, {});
  }

  // POST /integrations/scim-api-key
  public generateScimApiKey(): Observable<IGenerateKeyResult> {
    const url: string = this.restBuilder.create().integrations().scimApiKey().getApiUrl();

    return this.httpClient.post<IGenerateKeyResult>(url, {});
  }

  // GET /integrations/scim-api-key
  public getScimApiKey(): Observable<IPreviousTokensServerResponse | null> {
    const url: string = this.restBuilder.create().integrations().scimApiKey().getApiUrl();

    return this.httpClient.get<IPreviousTokensServerResponse>(url);
  }
}
